import React from "react";
import { Button } from "@/ui";

// ConfirmAction (Rule 3): the assistant proposes, the person decides. Shows a
// plain-language preview and waits for a clear yes. Nothing saves silently.
export default function ConfirmAction({
  open, title, preview = [], confirmLabel = "Yes, do it", cancelLabel = "No, go back",
  busy = false, error = "", onConfirm, onCancel,
}) {
  if (!open) return null;
  return (
    <div className="overlay center" role="dialog" aria-modal="true" aria-label={title}
      onMouseDown={(e) => e.target === e.currentTarget && !busy && onCancel?.()}>
      <div className="modal">
        <h2 className="t-h2" style={{ marginBottom: 8 }}>{title}</h2>
        <p className="muted t-small" style={{ marginBottom: 12 }}>here is exactly what will happen. nothing is saved until you say yes.</p>
        <ul className="stack" style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {preview.map((line, i) => (
            <li key={i} className="row" style={{ alignItems: "flex-start", gap: 8 }}>
              <span className="chip" style={{ width: 24, height: 24, padding: 0, justifyContent: "center" }}>{i + 1}</span>
              <span className="t-body">{line}</span>
            </li>
          ))}
        </ul>
        {error ? <div className="err-text" data-testid="confirm-error" style={{ marginTop: 12 }}>{error}</div> : null}
        <div className="actions">
          <Button data-testid="confirm-cancel" onClick={onCancel} disabled={busy}>{cancelLabel}</Button>
          <Button variant="primary" data-testid="confirm-ok" onClick={onConfirm} loading={busy}>{confirmLabel}</Button>
        </div>
      </div>
    </div>
  );
}
